import React from "react";
import { useTranslation } from "react-i18next";
import ReferenceListPage from "../components/ReferenceListPage";
import { contactReasonsAPI } from "../services/api";
import { loadContactReasons } from "../store/slices/referenceDataSlice";
import { PERMISSIONS } from "../utils/permissions";

const ContactReasonsPage = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <ReferenceListPage
      title={t("sidebar.contactReasons")}
      api={contactReasonsAPI}
      reloadThunk={loadContactReasons}
      requiredPermission={PERMISSIONS.MANAGE_CONTACT_REASONS}
      onNavigate={onNavigate}
      columns={[
        { field: "reason_id", label: "#" },
        { field: "name_en", label: t("referencePages.nameEn") },
        { field: "name_ar", label: t("referencePages.nameAr") },
      ]}
      formFields={[
        {
          name: "name_en",
          label: t("referencePages.nameEn"),
          required: true,
        },
        {
          name: "name_ar",
          label: t("referencePages.nameAr"),
          required: true,
        },
      ]}
    />
  );
};

export default ContactReasonsPage;
